import React, { Component } from "react";

export class Step7Requirement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expectedBudget: props.formData.expectedBudget || "",
      expectedStartDate: props.formData.expectedStartDate || "",
      expectedDelivery: props.formData.expectedDelivery || "",
      haveReference: props.formData.haveReference || "No",
      referenceWebsite: props.formData.referenceWebsite || "",
      additionalRequirement: props.formData.additionalRequirement || "",
      attachment: props.formData.attachment || null,
      contactMethod: props.formData.contactMethod || "Phone Call",
      error: "",
    };
  }

  handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      this.setState({
        [name]: files[0],
      });
    } else {
      this.setState({
        [name]: value,
        error: "",
      });
    }
  };

  handleNext = () => {
    this.props.updateFormData({
      expectedBudget: this.state.expectedBudget,
      expectedStartDate: this.state.expectedStartDate,
      expectedDelivery: this.state.expectedDelivery,
      haveReference: this.state.haveReference,
      referenceWebsite: this.state.referenceWebsite,
      additionalRequirement: this.state.additionalRequirement,
      attachment: this.state.attachment,
      contactMethod: this.state.contactMethod,
    });

    this.props.nextStep();
  };

  render() {
    return (
      <div className="container py-4">
        <div className="card shadow border-0">

          <div className="card-header bg-primary text-white">
            <h3 className="mb-0">
              Step 7 : Additional Requirements
            </h3>
          </div>

          <div className="card-body">

            <div className="row">

              {/* Budget */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Expected Budget
                </label>

                <select
                  className="form-select"
                  name="expectedBudget"
                  value={this.state.expectedBudget}
                  onChange={this.handleChange}
                >
                  <option value="">Select Budget</option>
                  <option>Below ₹25,000</option>
                  <option>₹25,000 - ₹50,000</option>
                  <option>₹50,000 - ₹1,00,000</option>
                  <option>₹1,00,000 - ₹5,00,000</option>
                  <option>Above ₹5,00,000</option>
                </select>
              </div>

              {/* Start Date */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Expected Project Start Date
                </label>

                <input
                  type="date"
                  className="form-control"
                  name="expectedStartDate"
                  value={this.state.expectedStartDate}
                  onChange={this.handleChange}
                />
              </div>

              {/* Delivery */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Expected Delivery Time
                </label>

                <select
                  className="form-select"
                  name="expectedDelivery"
                  value={this.state.expectedDelivery}
                  onChange={this.handleChange}
                >
                  <option value="">Select</option>
                  <option>Within 7 Days</option>
                  <option>Within 15 Days</option>
                  <option>Within 1 Month</option>
                  <option>Within 2 Months</option>
                  <option>Within 3 Months</option>
                  <option>More than 3 Months</option>
                </select>
              </div>

              {/* Reference */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Do you have a reference website/app?
                </label>

                <select
                  className="form-select"
                  name="haveReference"
                  value={this.state.haveReference}
                  onChange={this.handleChange}
                >
                  <option>No</option>
                  <option>Yes</option>
                </select>
              </div>

              {/* Reference URL */}
              {this.state.haveReference === "Yes" && (
                <div className="col-12 mb-3">
                  <label className="form-label">
                    Reference Website / App URL
                  </label>

                  <input
                    type="url"
                    className="form-control"
                    name="referenceWebsite"
                    placeholder="https://example.com"
                    value={this.state.referenceWebsite}
                    onChange={this.handleChange}
                  />
                </div>
              )}

              {/* Attachment */}
              <div className="col-12 mb-3">
                <label className="form-label">
                  Upload Requirement Document (Optional)
                </label>

                <input
                  type="file"
                  className="form-control"
                  name="attachment"
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  onChange={this.handleChange}
                />

                <small className="text-muted">
                  Accepted: PDF, DOC, DOCX, JPG, PNG
                </small>

                {this.state.attachment && (
                  <div className="mt-2 text-success">
                    <strong>Selected File:</strong>{" "}
                    {this.state.attachment.name}
                  </div>
                )}
              </div>

              {/* Additional Requirement */}
              <div className="col-12 mb-3">
                <label className="form-label">
                  Additional Requirements
                </label>

                <textarea
                  rows="5"
                  className="form-control"
                  name="additionalRequirement"
                  placeholder="Describe any additional requirements..."
                  value={this.state.additionalRequirement}
                  onChange={this.handleChange}
                />
              </div>

              {/* Contact Method */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Preferred Contact Method
                </label>

                <select
                  className="form-select"
                  name="contactMethod"
                  value={this.state.contactMethod}
                  onChange={this.handleChange}
                >
                  <option>Phone Call</option>
                  <option>WhatsApp</option>
                  <option>Email</option>
                  <option>Google Meet</option>
                  <option>Zoom Meeting</option>
                </select>
              </div>

            </div>

            {this.state.error && (
              <div className="alert alert-danger">
                {this.state.error}
              </div>
            )}

            <hr />

            <div className="d-flex justify-content-between">

              <button
                className="btn btn-outline-secondary"
                onClick={this.props.prevStep}
              >
                Previous
              </button>

              <button
                className="btn btn-primary"
                onClick={this.handleNext}
              >
                Review Details
              </button>

            </div>

          </div>

        </div>
      </div>
    );
  }
}

export default Step7Requirement;